<template>
  <div class="pa-5" style="height: 100%">
    <div class="d-flex align-center">
      <v-text-field v-model="file" outlined prepend-inner-icon="mdi-file" disabled hide-details></v-text-field>
      <v-btn color="primary" @click="cancelChooseFile" text>Chọn tệp khác</v-btn>
    </div>
    <div v-if="isError">
      <h2 class="pt-4 pb-2 red--text">Lỗi dữ liệu</h2>
      <p class="red--text">Vui lòng kiểm tra dữ liệu của dòng {{ indexError }}</p>
    </div>
    <v-card>
      <v-data-table
        class="mt-4"
        mobile-breakpoint="0"
        :options.sync="options"
        item-key="studentCode"
        :headers="headers"
        :items="selectedStudent"
        sort-by="index"
        :footer-props="{
          'items-per-page-text': 'Hiển thị mỗi trang',
          'items-per-page-all-text': 'Tất cả'
        }"
      >
        <template v-slot:top="{ pagination, options, updateOptions }">
          <v-data-footer
            :items-per-page="5"
            :pagination="pagination"
            :options.sync="options"
            :items-per-page-options="selectedStudent.length > 100 ? [5, 10, 15] : [5, 10, 15, -1]"
            @update:options="updateOptions"
            items-per-page-text="Học sinh mỗi trang"
            items-per-page-all-text="Tất cả"
          />
          <h3 class="previewFile" v-if="!isError">Xem trước tệp</h3>
        </template>
        <template v-slot:[`footer.page-text`]="items">
          {{ items.pageStart }} - {{ items.pageStop }} trên
          {{ items.itemsLength }}
        </template>
        <template v-slot:[`header.name`]="{ header }">
          <span class="pl-2">
            {{ header.text }}
          </span>
        </template>
        <template v-slot:[`item.stt`]="{ index, item }">
          <span v-if="isError" class="red--text">{{ item.index }}</span>
          <span v-else>{{ options.itemsPerPage * (options.page - 1) + index + 1 }}</span>
        </template>
        <template v-slot:[`item.name`]="{ item }">
          <div class="pl-2 py-2">
            <span>{{ item.name }}</span>
            <br />
            <span class="caption">{{ item.code }}</span>
          </div>
        </template>
        <template v-slot:[`item.status`]="{ item }">
          <v-chip small class="white--text" v-if="item.status" :color="getColor(item.status)" label>
            {{ item.status }}
          </v-chip>
        </template>
        <template v-slot:[`item.currentClass`]="{ item }">
          <span v-if="item.currentClass && item.currentClass.title">{{ item.currentClass.title }}</span>
          <span v-else>{{ item.class ? item.class : '' }}</span>
        </template>
        <template v-slot:[`item.gender`]="{ item }">
          <span>{{ item.gender }}</span>
        </template>
        <template v-slot:[`item.dob`]="{ item }">
          <span>{{ item.dob }}</span>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex'
import { getHeader } from '../helper/headerTable'

export default {
  props: {
    file: String,
    isError: Boolean
  },
  data() {
    return {
      options: {}
    }
  },
  methods: {
    ...mapMutations('tuitionFeeGroupStudent', ['setSelectedStudent']),
    cancelChooseFile() {
      this.$emit('reset')
      this.setSelectedStudent([])
    },
    getColor(status) {
      if (status === 'active' || status === 'Đang học') return '#46BE8A'
      else if (status === 'Bảo lưu' || status === 'reserved') return 'orange'
      else if (status === 'Đã tốt nghiệp' || status === 'graduated') return 'primary'
      else if (status === 'Đã nghỉ' || status === 'left') return 'red'
      else return 'grey'
    },
    getGender(gender) {
      if (gender === 'male') return 'Nam'
      else if (gender === 'female') return 'Nữ'
      return 'Khác'
    }
  },
  computed: {
    headers() {
      return getHeader('import')
    },
    ...mapState('tuitionFeeGroupStudent', ['selectedStudent']),
    indexError() {
      let arr = []
      if (this.isError) {
        for (let item of this.selectedStudent) {
          arr.unshift(item.index)
        }
      }
      return arr.join(', ')
    }
  }
}
</script>
<style scoped>
.previewFile {
  position: absolute;
  top: 2.1%;
  left: 1.5%;
  color: #0d47a1;
}
</style>
